import { createFileRoute } from "@tanstack/react-router"

import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/admin-settings/users/")({
  component: lazyImportRouteComponent(
    () => import("./-components/UsersPage"),
    "UsersPage"
  ),
})
